// Dependencies
import React, { FC } from "react"

// Types
import { PostTemplatePostFragmentFragment } from "@graphqlTypes"

// Utils
import { oneLineHelpScout } from "@utils"

// PostHeroBlog Components
import PostAuthors from "./components/PostAuthors/PostAuthors"
import PostHeroImage from "./components/PostImage/PostImage"

// Styled Components
import {
  PostHeroBlogHEADER,
} from "./PostHeroBlog.styles"

type PostHeroBlogProps = {
  authors: PostTemplatePostFragmentFragment["authors"],
  dateModified: PostTemplatePostFragmentFragment["dateModified"] | PostTemplatePostFragmentFragment["updatedAt"],
  image: PostTemplatePostFragmentFragment["image"],
  imageArtist: PostTemplatePostFragmentFragment["imageArtist"],
  imageBackgroundColor: PostTemplatePostFragmentFragment["imageBackgroundColor"],
  title: PostTemplatePostFragmentFragment["title"],
  useExtendedImage: PostTemplatePostFragmentFragment["useExtendedImage"],
}

const PostHeroBlog: FC<PostHeroBlogProps> = ({
  authors,
  dateModified,
  image,
  imageArtist,
  imageBackgroundColor,
  title,
  useExtendedImage,
}) => {
  const altText = image?.title ? image.title : title

  return (
    <PostHeroBlogHEADER>
      <div className="container">
        <div className="grid">
          <div className="column column--2-12-M column--3-11-L">
            <h1
              dangerouslySetInnerHTML={{
                __html: oneLineHelpScout(title || ""),
              }}
            />
            <PostAuthors authors={authors} date={dateModified} />
          </div>
          <div className="column column--2-12-L">
            <PostHeroImage
              image={image?.imgixImage?.gatsbyImageData}
              imageArtist={imageArtist}
              imageAltText={altText || "Post Image"}
              imageBackgroundColor={imageBackgroundColor}
              useExtendedImage={useExtendedImage}
            />
          </div>
        </div>
      </div>
    </PostHeroBlogHEADER>
  )
}

export default PostHeroBlog
